import { usePublicOrSecureFileUrl } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";

export interface SignaturePdfDocumentProps {
  pdfAttachment: string;
}

export const SignaturePdfDocument = ({ pdfAttachment }: SignaturePdfDocumentProps) => {
  const { t } = useTranslation("forms");
  const pdfUrl = usePublicOrSecureFileUrl(pdfAttachment, { preferInBrowser: true });

  if (!pdfUrl) return null;

  return (
    <div className="flex flex-col gap-1">
      <iframe title={t("Document to sign")} src={pdfUrl} className="w-full h-96 border rounded" />
      <a className="underline text-sm" href={pdfUrl} target="_blank" rel="noreferrer">
        {t("View document in new tab")}
      </a>
    </div>
  );
};
